import React, { useEffect, useState } from "react";
import { Container, Grid, Input, Dropdown, Button, Icon } from "semantic-ui-react";
import cx from "classnames";
import _ from "lodash";
import styles from "./generate_report_management.module.scss";
import Reports from "./Reports";
import GenerateReport from "./Generate";
import DatePicker from "react-datepicker";
import { LuRefreshCcw } from "react-icons/lu";

export default function GenerateReports({ account, setGoBackPath }) {
  const [loading, setLoading] = useState(false);
  const [openGenerateReportModal, setOpenGenerateReportModal] = useState(false);

  const [filters, setFilters] = useState({
    type: "ALL",
    status: "ALL",
    sort: "created_date",
    order: "DESC",
    fromDate: "",
    toDate: ""
  })

  useEffect(() => {
    setGoBackPath("/");
  }, []);

  const statusOptions = [
    { key: "all", text: "All", value: "ALL" },
    { key: "completed", text: "Completed", value: "COMPLETED" },
    { key: "inProgress", text: "In Progress", value: "IN_PROGRESS" },
    { key: "error", text: "Error", value: "ERROR" },
  ];

  const typeOptions = [
    { key: "all", text: "All", value: "ALL" },
    { key: "conversation", text: "Conversation Report", value: "CONVERSATION_REPORT" },
    { key: "userLogin", text: "User Login Report", value: "USER_LOGIN_REPORT" },
    { key: "masterAssetReport", text: "Master Asset Report", value: "MASTER_ASSET_REPORT" },
  ];

  const resetFilter = () => {
    setFilters({
      type: "ALL",
      status: "ALL",
      sort: "created_date",
      order: "DESC",
      fromDate: "",
      toDate: "",
    });
  };

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  return (
    <Container className={cx(styles.container)}>
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column className={cx(styles.title)}>
            {account ? account.name : " "}
          </Grid.Column>
          <Grid.Column textAlign="right">
            <Button
              className={cx(styles.btnCreate)}
              onClick={() => setOpenGenerateReportModal(!openGenerateReportModal)}
              content={
                <>
                  Generate Report{" "}
                  <span className={cx(styles.icon)}>
                    <Icon name="plus" />
                  </span>
                </>
              }
            />
          </Grid.Column>
        </Grid.Row>

        {/* Filters */}
        <Grid.Row columns={6}>
          <Grid.Column>
            <DatePicker
              selected={filters.fromDate ? new Date(filters.fromDate) : null}
              onChange={(date) => handleFilterChange("fromDate", date?.toISOString())}
              placeholderText="From Date"
              className={styles.randomDate}
              showYearDropdown
              dateFormat="dd-MM-yyyy"
              onKeyDown={(e) => e.preventDefault()}
            />
          </Grid.Column>
          <Grid.Column>
            <DatePicker
              selected={filters.toDate ? new Date(filters.toDate) : null}
              onChange={(date) => handleFilterChange("toDate", date?.toISOString())}
              placeholderText="To Date"
              className={styles.randomDate}
              showYearDropdown
              dateFormat="dd-MM-yyyy"
              onKeyDown={(e) => e.preventDefault()}
            />
          </Grid.Column>
          <Grid.Column>
            <Dropdown
              fluid
              selection
              placeholder="Select Type"
              options={typeOptions}
              value={filters.type}
              onChange={(e, { value }) => handleFilterChange("type", value)}
            />
          </Grid.Column>
          <Grid.Column>
            <Dropdown
              fluid
              selection
              placeholder="Select Status"
              options={statusOptions}
              value={filters.status}
              onChange={(e, { value }) => handleFilterChange("status", value)}
            />
          </Grid.Column>
          <Grid.Column>
            <button
              onClick={resetFilter}
              className={cx(styles.resetButton)}
            >
              <LuRefreshCcw /> Reset
            </button>
          </Grid.Column>
          <Grid.Column>
            <div className={cx(styles.sort)}>
              <span>
                <Icon
                  name="arrow up"
                  className={cx(styles.icon, filters.order === "ASC" && styles.active)}
                  onClick={() => handleFilterChange("order", "ASC")}
                />
                <Icon
                  name="arrow down"
                  className={cx(styles.icon, filters.order === "DESC" && styles.active)}
                  onClick={() => handleFilterChange("order", "DESC")}
                />
              </span>
              Created Date
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Reports account={account} setLoading={setLoading} filters={filters} />

      <GenerateReport
        account={account}
        open={openGenerateReportModal}
        setOpen={setOpenGenerateReportModal}
      />
    </Container>
  );
}